import { render, staticRenderFns } from "./SourceTab.vue?vue&type=template&id=753439db&scoped=true"
import script from "./SourceTab.vue?vue&type=script&lang=js"
export * from "./SourceTab.vue?vue&type=script&lang=js"
import style0 from "./SourceTab.vue?vue&type=style&index=0&id=753439db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753439db",
  null
  
)

export default component.exports